<section class="inner-page-header" [style.padding-top]="topOffset()">
  @if (backCta(); as cta) {
  <div
    class="inner-page-header__back-cta"
    [style.margin-bottom]="backCtaMarginBottom()"
  >
    <common-back-nav-cta
      [label]="cta.text"
      [aria-label]="cta.ariaLabel ?? cta.text"
      [data-testid]="cta.dataTestId"
      mt="none"
      mb="none"
      [routerLink]="cta.routerLink ?? null"
      [queryParams]="cta.queryParams"
      [fragment]="cta.fragment"
      [href]="cta.href"
      (backNavRequested)="onBackCtaRequested()"
    />
  </div>
  }

  <div
    class="inner-page-header__title-row"
    [style.margin-bottom]="titleMarginBottom()"
  >
    <goab-text
      tag="h1"
      mt="none"
      mb="none"
      [size]="titleSize()"
      [attr.id]="titleId() ?? null"
      [attr.data-testid]="titleDataTestId() ?? null"
    >
      {{ title() }}
    </goab-text>

    <ng-content></ng-content>
  </div>
</section>
